import React, { useState, useRef, useEffect } from 'react';
import h337 from 'heatmap.js';
import Utils from '../../utils/utils';
import axios from 'axios';
import JSZip from 'jszip';
import './depression.css';
import Pop from '../../Component/pop';


const Depression = (props) => {
    const heatmapContainer = useRef(null);
    const canvasRef = useRef(null);
    const points = useRef([]);
    const [showPop, setShowPop] = useState(false);
    const apiURL = process.env.REACT_APP_API_URL + '/webgazer/upload.php'
    const [personType, setPersonType] = useState(0);
    const personTypeRef = useRef(0);
    const [personIndex, setPersonIndex] = useState(1);
    const personIndexRef = useRef(1);
    const [personFaceIndex, setPersonFaceIndex] = useState(1);
    const personFaceIndexRef = useRef(1);
    const heatmapInstanceRef = useRef(null);
    const [showHeatmap, setShowHeatmap] = useState(false);
    const picIndexRef = useRef(1);
    const scoreListRef = useRef([]);
    
    const [popInfo, setPopInfo] = useState(['title', 'message', 'botton'])
    const zipRef = useRef(null);
    const FacePara = [
        0,
        process.env.REACT_APP_PARAMETER_FACE_NEUTRAL,
        process.env.REACT_APP_PARAMETER_FACE_SAD,
        process.env.REACT_APP_PARAMETER_FACE_HAPPY,
        process.env.REACT_APP_PARAMETER_FACE_ANGRY,
    ]
    const GridFacePara = [
        process.env.REACT_APP_PARAMETER_GRID_FACE_NEUTRAL,
        process.env.REACT_APP_PARAMETER_GRID_FACE_ANGRY,
        process.env.REACT_APP_PARAMETER_GRID_FACE_SAD,
        process.env.REACT_APP_PARAMETER_GRID_FACE_HAPPY,
    ]
    const initHeatmap = () => {
        zipRef.current = new JSZip()
        heatmapInstanceRef.current = h337.create({
            container: heatmapContainer.current,
            radius: 50,
            maxOpacity: 0.6,
            minOpacity: 0.1,
            blur: 0.75,
        })
    }

    const sendZip = async (score,level) => {
        console.log('sendZip');
        console.log(scoreListRef.current)
        const timestamp = Date.now();
        const csvData = ' ,Negative Emotion (Female),Negative Emotion (Male),Mean fixation time %' +
            '\nFixation Time %,' + scoreListRef.current[0]+',' +scoreListRef.current[1]+','+score+
            '\nResults (1 = high risk; 0 = normal),,,' + level;

        zipRef.current.file(`score.csv`, csvData);
        zipRef.current.generateAsync({ type: 'blob' }).then((zipBlob) => {
            const formData = new FormData();
            formData.append('heatmapZip', zipBlob, `heatmap_${timestamp}.zip`);
            const sessionUid = sessionStorage.getItem('uid');
            formData.append('uid', sessionUid);
            formData.append('score', score);
            formData.append('level', level);
            formData.append('type', 2);
            axios.post(apiURL, formData)
                .then((response) => {
                    console.log('Success:', response.data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    setPopInfo(['error', '上传失败', '返回'])
                });
        });
    }

    const countFocus = (pointArr) => {
        const newArr = pointArr.map((point, i) => {
            // point is { x: x, y: y, value: 1, radius: 50 }
            let valueCount = point.value;
            pointArr.forEach((other, j) => {
                if (i !== j) {
                    const dx = point.x - other.x;
                    const dy = point.y - other.y;
                    const distance = Math.sqrt(dx * dx + dy * dy);
                    // If other point is within the current point's radius
                    if (distance <= point.radius) {
                        valueCount += other.value;
                    }
                }
            });
            return { x: point.x, y: point.y, value: point.value, radius: point.radius, valueCount: valueCount };
        });
        const filteredPoints = newArr.filter(point => point.valueCount > 3);
        if (filteredPoints.length) {
            const xs = filteredPoints.map(p => p.x);
            const ys = filteredPoints.map(p => p.y);
            const minX = Math.min(...xs) - 30;
            const minY = Math.min(...ys) - 30;
            const maxX = Math.max(...xs) + 30;
            const maxY = Math.max(...ys) + 30;
            return { points: filteredPoints, rect: { x: minX, y: minY, width: maxX - minX, height: maxY - minY } };
        } else
            return null;
    };

    const getTestingRect = () => {
        // Find the active Testing element (it can be either the one for personType 2 or 3)
        const testingElems = document.getElementsByClassName('Testing');
        let activeElem = null;
        for (let elem of testingElems) {
            if (window.getComputedStyle(elem).display !== 'none') {
                activeElem = elem;
                break;
            }
        }
        // If no Testing element is visible, return all points
        if (!activeElem)
            return null;
        // Get the bounding rectangle of the Testing element
        else
            return activeElem.getBoundingClientRect();
    }

    const filterPoints = () => {
        const rect = getTestingRect()
        if (rect) {
            return points.current.filter(point =>
                point.x >= rect.left &&
                point.x <= rect.right &&
                point.y >= rect.top &&
                point.y <= rect.bottom
            );
        } else {
            return points.current;
        }
    };


    const countScoreType2 = (filteredPoints) => {
        if (filteredPoints) {
            const testingRect = getTestingRect()
            const rect = filteredPoints.rect;
            const score = (rect.width * rect.height) / (testingRect.width * testingRect.height) * 100 *
                Number(process.env.REACT_APP_PARAMETER_RECT) *
                FacePara[personFaceIndexRef.current]
            // const weight = filteredPoints.points.reduce((acc, point) => acc + point.value, 0) *
            //     Number(process.env.REACT_APP_PARAMETER_POINTS_COUNT)
            return Math.max(0, score);
        } else
            return 0
    }
    const countScoreType3 = (points) => {
        const midX = window.innerWidth / 2
        const midY = window.innerHeight / 2
        console.log('midX:', midX, 'midY:', midY)

        const scoreNeutral = points
            .filter(point => point.x < midX && point.y < midY)
            .reduce((acc, point) => acc + point.value, 0)
            * GridFacePara[0]
        const scoreAngry = points
            .filter(point => point.x > midX && point.y < midY)
            .reduce((acc, point) => acc + point.value, 0)
            * GridFacePara[1]
        const scoreSad = points
            .filter(point => point.x < midX && point.y > midY)
            .reduce((acc, point) => acc + point.value, 0)
            * GridFacePara[2]
        const scoreHappy = points
            .filter(point => point.x > midX && point.y > midY)
            .reduce((acc, point) => acc + point.value, 0)
            * GridFacePara[3]
        const sum = scoreNeutral + scoreAngry + scoreSad + scoreHappy
        console.log('Neutral:', scoreNeutral, 'Angry:', scoreAngry, 'Sad:', scoreSad, 'Happy:', scoreHappy, 'sum:', sum)
        return (scoreAngry + scoreSad) / sum * 100
    }

    const captureImage = async () => {
        console.log('Capture image');
        points.current = filterPoints()
        const data = { max: 3, data: points.current };
        let filteredPoints = null
        let imagePaths
        if (personTypeRef.current === 2) {
            filteredPoints = countFocus(points.current)
            console.log('pointRect:', filteredPoints)
            imagePaths = [
                `${process.env.PUBLIC_URL}/person/p${personIndexRef.current}_${personFaceIndexRef.current}.jpg`
            ];
            const score = countScoreType2(filteredPoints)
            scoreListRef.current.push(score)
            console.log('score:', score)
        } else {
            imagePaths = [
                `${process.env.PUBLIC_URL}/person/p${personIndexRef.current}_3.jpg`,
                `${process.env.PUBLIC_URL}/person/p${personIndexRef.current}_1.jpg`,
                `${process.env.PUBLIC_URL}/person/p${personIndexRef.current}_4.jpg`,
                `${process.env.PUBLIC_URL}/person/p${personIndexRef.current}_2.jpg`
            ];
            const score = countScoreType3(points.current)
            scoreListRef.current.push(score)
            console.log('score:', score)
        }
        heatmapInstanceRef.current.setData(data);
        const backgroundCanvas = canvasRef.current;
        const ctx = backgroundCanvas.getContext('2d', { willReadFrequently: true });
        // 设置背景画布大小与热力图容器一致
        backgroundCanvas.width = heatmapContainer.current.offsetWidth;
        backgroundCanvas.height = heatmapContainer.current.offsetHeight;



        Promise.all(
            imagePaths.map(src =>
                new Promise(resolve => {
                    const img = new Image();
                    img.src = src;
                    img.onload = () => resolve(img);
                })
            )
        ).then(images => {
            console.log('Images loaded:', images.length);
            const gridCols = Math.sqrt(images.length)
            const gridRows = Math.sqrt(images.length)
            const cellWidth = backgroundCanvas.width / gridCols;
            const cellHeight = backgroundCanvas.height / gridRows;
            images.forEach((img, idx) => {
                const ratio = Math.min(cellWidth / img.width, cellHeight / img.height);
                const newWidth = img.width * ratio;
                const newHeight = img.height * ratio;

                let dx = backgroundCanvas.width / 2
                if (idx % gridCols === 0)
                    dx = backgroundCanvas.width / 2 - gridCols * newWidth / 2
                const dy = Math.floor(idx / gridCols) * cellHeight + (cellHeight - newHeight) / 2;
                ctx.drawImage(img, dx, dy, newWidth, newHeight);
            });
            if (filteredPoints) {
                ctx.strokeStyle = 'red';
                ctx.lineWidth = 2;
                ctx.strokeRect(
                    filteredPoints.rect.x,
                    filteredPoints.rect.y,
                    filteredPoints.rect.width,
                    filteredPoints.rect.height
                );
            }
            const heatmapCanvas = heatmapContainer.current.querySelector('canvas');
            ctx.drawImage(heatmapCanvas, 0, 0, heatmapCanvas.width, heatmapCanvas.height);
            const dataURL = backgroundCanvas.toDataURL('image/png');
            fetch(dataURL)
                .then(response => response.blob())
                .then(imgBlob => {
                    const csvData = 'x,y,val\n' + points.current.map(point => `${parseInt(100*point.x/backgroundCanvas.width)},${parseInt(100*point.y/backgroundCanvas.height)},${point.value}`).join('\n');
                    const csvBlob = new Blob([csvData], { type: 'text/csv' });
                    zipRef.current.file(`Data_${picIndexRef.current}.csv`, csvBlob);
                    zipRef.current.file(`Img_${picIndexRef.current}.png`, imgBlob);
                    picIndexRef.current += 1;
                });
        });
    }


    const startGame = async () => {
        console.log('startGame')
        let personGridArr = [2, 5]
        picIndexRef.current = 1
        scoreListRef.current = []
        // for (let person of personArr) {
        //     for (let face of faceArr) {
        //         setPersonType(1)
        //         await Utils.sleep(1000)
        //         setPersonIndex(person)
        //         setPersonFaceIndex(face)
        //         setPersonType(2)
        //         await Utils.sleep(5000)
        //         await captureImage()
        //     }
        // }
        for (let person of personGridArr) {
            setShowHeatmap(false);
            setPersonType(1)
            await Utils.sleep(1000)
            points.current = [];
            setPersonIndex(person)
            setPersonType(3)
            await Utils.sleep(10000)
            await captureImage()
            setShowHeatmap(true);
            await Utils.sleep(3000)
        }
        setShowPop(true);
        const score = Math.floor((scoreListRef.current.reduce((acc, currentValue) => acc + currentValue, 0))/2);
        const level = score < 50 ? 0 : 1
        setPopInfo(['憂鬱症篩查測試結果', '計算中', ''])
        await Utils.sleep(1000)
        setPopInfo(['憂鬱症篩查測試結果', `分數:${score}<br/>屬${level===0 ? '正常水平' : '高風險'}`, 'upload'])
        await sendZip(score,level)
        setPopInfo(['憂鬱症篩查測試結果', `分數:${score}<br/>屬${level===0 ? '正常水平' : '高風險'}`, '返回'])

    }

    const onBackSelect = () => {
        setShowPop(false);
        setShowHeatmap(false);
        props.onBackSelect();
    }
    useEffect(() => {
        console.log('Component initialized');
        startGame();
        initHeatmap();

        return () => {
            console.log('Component will unmount');
        }
    }, []);
    useEffect(() => {
        let x = Math.floor(props.eyePoint[0] * window.innerWidth/100)
        let y = Math.floor(props.eyePoint[1] * window.innerHeight/100)

        const existingPoint = points.current.find(point => point.x === x && point.y === y);
        if (existingPoint) {
            if (existingPoint.value < 3)
                existingPoint.value += 1;
        } else {
            points.current.push({ x: x, y: y, value: 1, radius: 50 });
        }
    }, [props.eyePoint]);
    useEffect(() => {
        personIndexRef.current = personIndex;
        personFaceIndexRef.current = personFaceIndex;
        personTypeRef.current = personType;
    }, [personFaceIndex, personIndex, personType]);
    return (
        <div className="Depression" style={{ minHeight: '100vh', width: '100vw', position: 'relative' }}>
            
            {showPop ? <Pop onClose={onBackSelect} info={popInfo} ></Pop> : ''}
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: personType === 1 ? 'block' : 'none',
                zIndex: 2,
                gap: '10px'
            }}>
                <img src={`${process.env.PUBLIC_URL}/res/focus.png`} alt="Focus" />
            </div>
            <div className="Testing" style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                height: '100vh',
                transform: 'translate(-50%, -50%)',
                display: personType === 2 ? 'block' : 'none',
                zIndex: 2,
                gap: '10px'
            }}>
                <img src={`${process.env.PUBLIC_URL}/person/p${personIndex}_${personFaceIndex}.jpg`} alt="Person" />
            </div>            <div className="Testing" style={{
                height: '100vh',
                width: '100vw',
                maxHeight: '100vw',
                maxWidth: '100vh',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 2,
                display: personType === 3 ? 'grid' : 'none',
                gridTemplateColumns: '1fr 1fr',
                gridTemplateRows: '1fr 1fr',
            }}>
                <img 
                    src={`${process.env.PUBLIC_URL}/person/p${personIndex}_3.jpg`} 
                    alt="Person1" 
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '8px'
                    }}
                />
                <img 
                    src={`${process.env.PUBLIC_URL}/person/p${personIndex}_1.jpg`} 
                    alt="Person2" 
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '8px'
                    }}
                />
                <img 
                    src={`${process.env.PUBLIC_URL}/person/p${personIndex}_4.jpg`} 
                    alt="Person3" 
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '8px'
                    }}
                />
                <img 
                    src={`${process.env.PUBLIC_URL}/person/p${personIndex}_2.jpg`} 
                    alt="Person4" 
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '8px'
                    }}
                />
            </div>

            <div className="heatmap"
                ref={heatmapContainer}
                style={{
                    opacity: showHeatmap ? 0.9 : 0.01,
                    width: '100vw',
                    height: '100vh',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 99,
                    pointerEvents: 'none',
                    background: 'transparent',
                }}
            ></div>
            <div
                style={{
                    width: '100vw',
                    height: '100vh',
                    position: 'absolute',
                    background: `url(${process.env.PUBLIC_URL + '/res/pic' + props.picIndex + '.jpg'}) no-repeat center center / cover`,
                    top: 0,
                    left: 0,
                }}>
            </div>
            <canvas ref={canvasRef} style={{
                display: 'none',
                width: '100vw',
                height: '100vh',
            }}></canvas>
        </div>
    )
};

export default Depression;
